// extracted by mini-css-extract-plugin
export default {"enum":"EnumElement_enum__+lFtk"};